// Copyright (c) 2026 Finerty Data Ltd. All rights reserved.
//
// This file is part of proprietary software owned by Finerty Data Ltd.
// It is confidential and may not be copied, distributed, modified, or used,
// in whole or in part, without the prior written consent of Finerty Data Ltd.
//
// Author: Ahmed Hosny

import React from 'react';
import type { ProfileRequestType } from '../../types/profileRequest';

/** Human-readable copy for each request type. The pill styling is uniform
 * across types (a purple chip) — only the label varies. */
const LABELS: Record<ProfileRequestType, string> = {
  LOA:                      'LOA',
  COA:                      'CoA',
  RETIREMENT_OPTIONS:       'Retirement options',
  LEAVE_OF_SERVICE_OPTIONS: 'Leave of service',
  OPEN_BANKING_CONNECTION:  'Open Banking Connection',
  KYC_VERIFICATION:         'KYC',
  FACT_FIND:                'Fact find',
  RISK_ATTITUDE:            'Risk assessment',
  SUSTAINABILITY:           'Sustainability',
  NEW_BUSINESS_APPLICATION: 'New Business',
  ANNUAL_REVIEW:            'Annual review',
  AML_DOCUMENTATION:        'AML',
};

export const RequestTypeBadge: React.FC<{ type: ProfileRequestType }> = ({ type }) => {
  const label = LABELS[type] ?? type;
  return (
    <span
      data-testid={`request-type-badge-${type}`}
      style={{
        display: 'inline-flex',
        padding: '4px 8px',
        justifyContent: 'center',
        alignItems: 'center',
        gap: 4,
        borderRadius: 4,
        background: '#EAE6F0', // --purple-primary-purple-06
        overflow: 'hidden',
        color: '#2D0A6C', // --purple-primary-purple-01
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        fontFamily: '"Google Sans", sans-serif',
        fontSize: 14,
        fontStyle: 'normal',
        fontWeight: 500,
        lineHeight: 'normal',
        textTransform: 'capitalize',
      }}
    >
      {label}
    </span>
  );
};
